'use client'

// libraries
import clsx from 'clsx'

// components
import Hero, { HeroProps } from '/react4xp/components/Hero'
import Section from '/react4xp/components/Section'
import RoundedBox from '/react4xp/components/RoundedBox'

// utils
import useTableWrapper from '/react4xp/utils/useTableWrapper'
import { formatDate } from '/react4xp/utils/functions'

// css
import './index.scss'

// types
interface ArtiklerProps {
    className?: string
    hero?: HeroProps
    author?: {
        label?: string
        name?: string
        url?: string
    }
    reviewedBy?: {
        text?: string
    }
    tags?: {
        label?: string
        items?: string[]
    }
    publicationDate?: {
        label?: string
        date?: string
    }
    updatedDate?: {
        label?: string
        date?: string
    }
    content?: React.ReactNode
    mainRegion?: React.ReactNode
    supplementaryRegion?: React.ReactNode
    text1?: string
    text2?: string
}

export default function Artikler({
    className,
    hero,
    author,
    reviewedBy,
    tags,
    publicationDate,
    updatedDate,
    content,
    mainRegion,
    supplementaryRegion,
    text1,
    text2
}: ArtiklerProps) {

    useTableWrapper()

    return (
        <div className={clsx('page-artikler', className)}>

            {hero && (
                <Hero {...hero} />
            )}

            <Section className='page-artikler__content'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-10 offset-lg-1 col-xl-6 offset-xl-3'>

                            {(author?.name || reviewedBy?.text || (tags?.items && tags.items.length > 0) || publicationDate?.date || updatedDate?.date) && (
                                <div className='page-artikler__meta'>

                                    {author?.name && (
                                        <p className='page-artikler__author'>
                                            {author.label && (
                                                <span className='page-artikler__author-label'>{author.label}: </span>
                                            )}
                                            {author.url ? (
                                                <a className='page-artikler__author-link' href={author.url}>{author.name}</a>
                                            ) : (
                                                <span className='page-artikler__author-name'>{author.name}</span>
                                            )}
                                        </p>
                                    )}

                                    {reviewedBy?.text && (
                                        <p className='page-artikler__reviewed-by'>{reviewedBy.text}</p>
                                    )}

                                    {tags?.items && tags.items.length > 0 && (
                                        <div className='page-artikler__tags'>
                                            {tags.label && (
                                                <span className='page-artikler__tags-label'>{tags.label}:</span>
                                            )}
                                            <ul className='page-artikler__tags-list'>
                                                {tags.items.map(function (tag) {
                                                    return (
                                                        <li key={tag} className='page-artikler__tag'>
                                                            {tag}
                                                        </li>
                                                    )
                                                })}
                                            </ul>
                                        </div>
                                    )}

                                    {(publicationDate?.date || updatedDate?.date) && (
                                        <RoundedBox
                                            bgColor='beige'
                                            className='page-artikler__publication-date'
                                        >

                                            {publicationDate?.date && (
                                                <span className='page-artikler__publication-date__span'>
                                                    <span>{publicationDate.label}</span>
                                                    <span>{formatDate(publicationDate.date || '')}</span>
                                                </span>
                                            )}

                                            {updatedDate?.date && (
                                                <span className='page-artikler__publication-date__span'>
                                                    <span>{updatedDate.label}</span>
                                                    <span>{formatDate(updatedDate.date || '')}</span>
                                                </span>
                                            )}

                                        </RoundedBox>
                                    )}

                                </div>
                            )}

                            {content && (
                                <div className='rich-text-article'>
                                    {content}
                                </div>
                            )}

                            {text1 && (
                                <div className='rich-text-article' dangerouslySetInnerHTML={{ __html: text1 }} suppressHydrationWarning />
                            )}

                        </div>
                    </div>
                </div>
            </Section>

            {mainRegion && (
                <>
                    {mainRegion}
                </>
            )}

            {text2 && (
                <Section className='page-artikler__content'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-10 offset-lg-1 col-xl-6 offset-xl-3'>
                                <div className='rich-text-article' dangerouslySetInnerHTML={{ __html: text2 }} suppressHydrationWarning />
                            </div>
                        </div>
                    </div>
                </Section>
            )}

            {supplementaryRegion && (
                <div className='page-artikler__supplementary'>
                    {supplementaryRegion}
                </div>
            )}

        </div>
    )
}
